<script setup>
import {reactive,onMounted,computed,watch} from "vue";
import mapboxgl from "mapbox-gl";
import {ApiWrapper} from "@/Utils/ApiWrapper";
import dayjs from "dayjs";
import checklist from './checklist.png';
import {ToastUtil} from "@/Utils/ToastUtil";

const data = reactive({
  localPath: '',
  search: null,
  dataLoading: true,
  newAdj: false,
  map: null,
  popup: '',
  geodata: [],
  items: [],
  timeoutid: null
});

const openFullscreen = () => {
  let elem = document.getElementById("map");
  if (elem.requestFullscreen) {
    elem.requestFullscreen();
  } else if (elem.webkitRequestFullscreen) { /* Safari */
    elem.webkitRequestFullscreen();
  } else if (elem.msRequestFullscreen) { /* IE11 */
    elem.msRequestFullscreen();
  }
}

const getData = async() => {
  data.dataLoading = true
  ApiWrapper.post('claims', 'get-unassigned', {})
      .then((response) => {
        if(response) {
          if(response.geodata) {
            data.geodata = response.geodata
          }
          if(response.data) {
            data.items = response.data
          }
        }
        createMapMarkers()
      })
      .catch((e)=>{
        ToastUtil.error(e);
      })
      .finally(() => {
        data.dataLoading = false
      })

  await new Promise(resolve => setTimeout(resolve, 30000));
  await getData();
}

const createMapMarkers = () => {
  if(data.map.getLayer('claim') !== undefined) {
    data.map.removeLayer('claim')
  }

  if(data.map.getSource('apps') !== undefined) {
    data.map.removeSource('apps')
  }

  data.map.addSource('apps', {
    type: 'geojson',
    data: data.geodata,
    cluster: false,
  });

  data.map.addLayer({
    id: 'claim',
    source: 'apps',
    type: 'symbol',
    layout: {
      'icon-image': 'claim',
      'icon-size': 0.10,
      'icon-anchor': 'bottom',
      'icon-allow-overlap': true,
    },
  });


  data.map.on('click', 'claim', function (e) {
    if (data.popup !== '') {
      data.popup.remove()
    }
    let stackedApps = []
    let coordinates = e.features[0].geometry.coordinates.slice()

    for (let x in e.features) {
      let newApp = {
        claimnumber: e.features[x].properties.claimnumber,
        claimid: e.features[x].properties.claimid,
        claimtype: e.features[x].properties.claimtype,
        streetaddress: e.features[x].properties.streetaddress,
        city: e.features[x].properties.city,
        state: e.features[x].properties.state,
        zip: e.features[x].properties.zip,
      }
      stackedApps.push(newApp)
    }
    let htmlString = ''
    for (let x in stackedApps) {
      htmlString +=
      `<div style="width: 175px; padding: 5px;">
          <h3>
            <a href="${ApiWrapper.localPath}/claim/${stackedApps[x].claimid}" target="_blank"> Claim: ${stackedApps[x].claimnumber}</a>
          </h3>
       </div>`
    }
    // let coordinates = e.features[0].geometry.coordinates.slice()
    // Ensure that if thedata.map is zoomed out such that
    // multiple copies of the feature are visible, the
    // popup appears over the copy being pointed to.
    while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
      coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360
    }

    data.popup = new mapboxgl.Popup()
        .setLngLat(coordinates)
        .setHTML(htmlString)
        .addTo(data.map)
  })
}

onMounted(() => {

  mapboxgl.accessToken =
      'pk.eyJ1IjoiZW50cmVvcyIsImEiOiJja2RydG16MXEwZ3hvMnhuOXVlcHZhcWRvIn0.mlZA3MAQSFupaQbmFjA9QQ'

  data.map = new mapboxgl.Map({
    container: 'map',
    style: 'mapbox://styles/mapbox/streets-v11',
    center: [-99.121313, 39.816975 ],
    zoom: 3,
  });

  data.map.on('load', function () {
    data.map.loadImage(checklist, function (error, image) {
      if (error) throw error
      data.map.addImage('claim', image)
    });

    getData();
  });

});

</script>

<template>
  <v-container fluid>
    <v-card class="elevation-2" height="auto" width="auto">
      <v-toolbar flat color="white">
        <v-toolbar-title>Unassigned Claims Map</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-btn size="small" variant="elevated" color="primary" @click="openFullscreen()">Open Map in Fullscreen Mode</v-btn>
      </v-toolbar>
      <v-row align="center">
        <v-col align="center" cols="12">
          <div id="map"></div>
        </v-col>
      </v-row>

    </v-card>
  </v-container>
</template>

<style scoped>
.container {
  padding: 5px;
}

[v-cloak] {
  display: none;
}

.mapboxgl-map {
  width: 100%;
  height: 1000px;
}
#map {
  top: 0;
  bottom: 0;
}
.marker {
  background-image: url('mapbox-A.png');
  background-size: cover;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  cursor: pointer;
}
.mapboxgl-popup-content {
  font-family: 'Oswald';
  box-shadow: 0 3px 14px rgba(0, 0, 0, 0.4);
}
.mapboxgl-popup-close-button {
  padding-right: 5px;
}
.mapboxgl-popup-content-wrapper {
  border-radius: 12px;
}

.transparent {
  background: rgba(0, 0, 0, 0);
}
</style>